// extracted by mini-css-extract-plugin
export var container = "Z+AagG-k";
export var containerVisible = "k2jE8mzb";
export var text = "CKR1yXh0";
export var shortlistCount = "KVvKcCsb";
export var confirmationLink = "hpB+8+IE";